import {
  Component,
  OnInit,
  AfterViewInit,
  NgZone,
  ChangeDetectorRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { AzureAuthService } from "src/app/services/azure-auth.service";
import { environment } from "src/environments/environment";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { RequestModel } from "src/app/Models/requestModel.model";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { trigger, transition, style, animate } from "@angular/animations";
import { GsdRoles } from "src/app/enums/gsdRoles.enum";
import { EmployeeService } from "../employee-profile/employee-profile.service";

declare const gapi: any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  animations: [
    trigger("revealAnimation", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateY(50px)" }),
        animate(
          "0.5s ease-out",
          style({ opacity: 1, transform: "translateY(0)" })
        ),
      ]),
    ]),
  ],
})
export class LoginComponent implements OnInit, AfterViewInit {
  isEdgeBrowser: boolean = false;
  public auth2: any;
  public loading = false;
  public noUser = false;
  public requested = false;
  public serverError = false;
  public formData: UntypedFormGroup;
  public role: string;
  public leadershipRole: boolean = false;
  employeeProfileStatus: any;
  employee: any;
  employeeId: number;
  constructor(
    public router: Router,
    public authService: AuthServiceService,
    private dialog: MatDialog,
    // tslint:disable-next-line: align
    private azureAuthService: AzureAuthService,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private auth: AuthServiceService,
    private employeeService: EmployeeService,

  ) { }

  ngOnInit() {

    const ua = navigator.userAgent;
    const isEdge = ua.includes("Edg") && !ua.includes("Chrome/");
    const isChromiumEdge = ua.includes("Edg/") && ua.includes("Chrome");
    this.isEdgeBrowser = isEdge || isChromiumEdge;
    this.createFormControls();
    const body = document.getElementsByTagName("body")[0];
    body.classList.add("custombg");
    this.employeeId = parseInt(localStorage.getItem("Id"))
    this.getEmployeeDetails(this.employeeId);
    this.getEmployeeDetails();
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName("body")[0];
    body.classList.remove("custombg");
  }

  ngAfterViewInit() {
  }

  private getJWTToken(sso_token) {

    this.loading = true;


    this.authService.getToken(sso_token).subscribe(res => {


      if (res.status === 204 || this.azureAuthService.azurenoUser) {
        this.noUser = true;
        this.createFormControls();
        this.cd.detectChanges();
        this.loading = false;
      }
      else if (res.status === 201) {
        this.requested = true;
        this.cd.detectChanges();
        this.loading = false;
      }
      else {
        this.authService.setLocalstorage(res.body, '');
        let redirectTo = localStorage.getItem('redirectTo')
        this.role = this.auth.getRole();
        if (this.role.includes(GsdRoles.Leadership)) {
          this.leadershipRole = true;
        }
        if (redirectTo) {
          this.router.navigate([redirectTo]).then(res => this.loading = false);
        }
        else if (this.leadershipRole) {
          this.router.navigate(['Home/skill-repo']).then(res => this.loading = false);
        }
        else {
          this.router.navigate(['/Home']).then(res => this.loading = false);
        }
      }

    }, err => {
      this.loading = false;
      this.serverError = true;
      this.noLoading();
    });
  }

  Reference() {
  }
  RequestAccess() {
    this.loading = true;
    const requestModel = new RequestModel();
    requestModel.contactNumber = this.formData.controls.ContactNumber.value;
    requestModel.referedBy = this.formData.controls.Refer.value;
    requestModel.userEmail = this.formData.controls.EmailId.value;

    this.authService.requestAccess(requestModel).subscribe(
      (res) => {
        this.requested = false;
        this.noUser = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: {
            message:
              "Requested for Access. Please wait while we process your request",
            class: "text-success",
          },
        });
        this.formData.reset();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: {
            message:
              "Internal server error.Please try after some time or contact Administrator",
            class: "text-danger",
          },
        });
      }
    );
  }

  login(company) {
    this.getSSOToken();
    this.noUser = false;
    this.requested = false;

    this.loading = true;
  }
  UnableToLogin() {
    this.router.navigate(['/login-issue']).then(res => this.loading = false);
  }

  getEmployeeDetails(empId?: number) {
    if (empId) {
      this.loading = true;
      this.employeeService.getEmployeeDetails(empId).subscribe(
        (res) => {
          this.employee = res.data;
          this.employeeProfileStatus = this.employee.employeeProfileStatus;
          this.loading = false;
          // localStorage.setItem('firstName',this.employee.firstName)
          // localStorage.setItem('lastName',this.employee.lastName)
        },
        (error) => {
          console.error('Error fetching employee details:', error);
          this.loading = false;
        }
      );
    }
  }


  getSSOToken() {
    window.open(environment.ssoUrl, '_self');
    this.loading = false;
  }

  noLoading() {
    this.loading = false;
  }

  createFormControls() {
    this.formData = new UntypedFormGroup({
      ContactNumber: new UntypedFormControl("", Validators.required),
      Refer: new UntypedFormControl("", Validators.required),
      EmailId: new UntypedFormControl("", Validators.required),
    });
  }
}
